import { Fab, Grid, Typography } from "@mui/material"
import CheckIcon from '@mui/icons-material/Check';

import CloseIcon from '@mui/icons-material/Close';
import AddIcon from "@mui/icons-material/Add";

import React, { useEffect, useState } from "react"
import { getAllGroup } from "../features/customerGrouping/customerGroupingApi"

export const Filter = ({ setGetDataPykoad, getDataPayload }) => {
  const [collectionOption, setCollectionOption] = useState([])
  const u1 = ["Birthdays", "Anniversaries"]

  useEffect(() => {
    getAllGroup((data) => {
      console.log("groupalldata", data)


      setCollectionOption(data?.data?.list)
    })
  }, [])
  return (
    <React.Fragment>
      <Grid container alignItems="center" sx={{
        zIndex: 0,
      }}>
        {/* Upcoming Section */}
        <Grid
          item
          xs={2}
          sx={{
            marginTop: "18px",
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            marginTop: "20px",
          }}
        >
          <Typography sx={{ fontWeight: "bold", marginLeft: "12px", marginBottom: "12px" }}>Upcoming:</Typography>
        </Grid>

        <Grid
          item
          xs={10}
          sx={{
            overflowX: "auto", // Automatically handle scroll when content overflows
            maxWidth: "100%",  // Ensures the container stays within screen width
            display: "flex",   // Flex layout for horizontal alignment
            marginTop: "20px",
            flexWrap: "nowrap", // Prevent items from wrapping to the next line
            paddingBottom: "10px", // Adds space at the bottom
          }}
        >
          {u1?.map((ele, index) => (
            <Fab
              key={index} // Unique key for each item in the list
              onClick={() => {
                setGetDataPykoad({ ...getDataPayload, filter: ele, search: "" })
                // setOpen(true)
              }}
              sx={{
                height: "40px",  // Adjusted height for better accessibility
                margin: "10px",
                textTransform: "capitalize",
                paddingX: "16px",
                whiteSpace: "nowrap",
              }}
              size="small"
              color="primary"
              variant="extended"
              aria-label="add"
            >
              {ele}
              {/* <AddIcon /> */}
            </Fab>
          ))}
        </Grid>

        <Grid
          item
          xs={2}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            marginBottom: "20px",
          }}
        >
          <Typography sx={{ fontWeight: "bold", marginLeft: "12px", marginBottom: "12px" }}>Groups:</Typography>
        </Grid>

        <Grid
          item
          xs={10}
          sx={{
            overflowX: "auto", // Handle overflow horizontally
            maxWidth: "100%",  // Ensure container fits within screen width
            display: "flex",   // Flex layout for horizontal alignment
            alignItems: "center",
            flexWrap: "nowrap", // Prevent wrapping of buttons
            paddingBottom: "10px",
            marginBottom: "20px",
            // Adds padding at the bottom
            /* Custom Scrollbar Styling */
            "&::-webkit-scrollbar": {
              height: "8px",
            },
            // "&::-webkit-scrollbar": {
            //   display: "none",  // Hides scrollbar for WebKit browsers
            // },
            // "-ms-overflow-style": "none",  // Hides scrollbar for IE and Edge
            // "scrollbar-width": "none", 
          }}
        >
          <Fab
            onClick={() => setGetDataPykoad({ ...getDataPayload, filter: "", search: "" })}
            sx={{
              height: "36px",
              margin: "5px",
              textTransform: "capitalize",
              whiteSpace: "nowrap",
              paddingX: "16px",
              fontSize: "14px",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "20px",
              minWidth: "auto",
              // marginBottom: "20px",
            }}
            size="small"
            color="primary"
            variant="extended"
            aria-label="add"
          >
            All
            {"" === getDataPayload?.search && <CheckIcon />}
          </Fab>

          {collectionOption?.map((ele, index) => (
            <Fab
              key={index} // Unique key for each item in the list
              onClick={() => setGetDataPykoad({ ...getDataPayload, filter: "customerGroup", search: ele?.customerGroupName })}
              sx={{
                height: "36px",
                margin: "5px",
                textTransform: "capitalize",
                whiteSpace: "nowrap",
                paddingX: "16px",
                fontSize: "14px",
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "20px",
                minWidth: "auto",
              }}
              size="small"
              color="primary"
              variant="extended"
              aria-label="add"
            >
              {ele?.customerGroupName}
              {ele?.customerGroupName === getDataPayload?.search && <CheckIcon />}
            </Fab>
          ))}
        </Grid>
      </Grid>
    </React.Fragment>
  )
}